import LOGO from "../images/pythons.png";

export const Team__Pythons = {
  name: "Pythons",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#ec85c3ff",
  teamJerseyColor: "#1B534C",

  // Stats
  gamesWon: 2,
  gamesLost: 1,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 37 + 28 + 23,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 33 + 53 + 36,
    },
  ],
};
